
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../styles/enquiryList.css";

const SAMPLE_ENQUIRIES = {
  "ENQ-2026-10-000241": {
    number: "ENQ-2026-10-000241",
    date: "23-Aug-2026",
    company: "ABC Industries Pvt Ltd",
    contact: "Rajesh Sharma",
    designation: "Plant Head",
    mobile: "+91 98765 43210",
    email: "rajesh@example.com",
    website: "www.example.com",
    industry: "Manufacturing",
    country: "India",
    state: "Maharashtra",
    city: "Mumbai",
    source: "Website",
    type: "Product Enquiry",
    status: "Qualified",
    priority: "High",
    owner: "Amit Sharma",
    territory: "Mumbai West",
    productInterest: "Industrial Automation Solution",
    quantity: "15",
    budget: "50 Lakhs",
    expectedTimeline: "3 Months",
    projectValue: "50 Lakhs",
    requirementDescription:
      "Automation solution required for new manufacturing line.",
    campaign: "Automation Campaign",
    score: 87,
    leadScore: 84,
    age: "4 Days",
    activities: 12,
    conversion: 78,
    sla: "On Track",
    lastActivity: "Today 10:15 AM",
    createdBy: "System",
    createdOn: "23-Aug-2026 09:00 AM",
    modifiedBy: "Amit Sharma",
    modifiedOn: "24-Aug-2026 10:15 AM",
    budgetAvailable: "Yes",
    decisionMaker: "Yes",
    requirementConfirmed: "Yes",
    timelineDefined: "Yes",
    existingVendor: "XYZ Automation",
    competitorIdentified: "Yes",
  },
  "ENQ-2026-10-000240": {
    number: "ENQ-2026-10-000240",
    date: "19-Oct-2026",
    company: "XYZ Technologies",
    contact: "Priya Nair",
    designation: "",
    mobile: "",
    email: "",
    website: "",
    industry: "Technology",
    country: "India",
    state: "",
    city: "",
    source: "Referral",
    type: "Product Enquiry",
    status: "In Progress",
    priority: "Medium",
    owner: "Neha Kapoor",
    territory: "",
    productInterest: "",
    quantity: "",
    budget: "",
    expectedTimeline: "",
    projectValue: "",
    requirementDescription: "",
    campaign: "",
    score: 64,
    leadScore: 61,
    age: "2 Days",
    activities: 3,
    conversion: 45,
    sla: "On Track",
    lastActivity: "Yesterday",
    createdBy: "System",
    createdOn: "19-Oct-2026 09:00 AM",
    modifiedBy: "Neha Kapoor",
    modifiedOn: "19-Oct-2026 11:00 AM",
    budgetAvailable: "Pending",
    decisionMaker: "Pending",
    requirementConfirmed: "Yes",
    timelineDefined: "Pending",
    existingVendor: "Unknown",
    competitorIdentified: "Pending",
  },
};

const ACTIVITY_ROWS = [
  {
    type: "Call",
    subject: "Qualification Call",
    due: "23-Aug-2026",
    owner: "Amit Sharma",
    status: "Completed",
  },
  {
    type: "Meeting",
    subject: "Product Discussion",
    due: "25-Aug-2026",
    owner: "Amit Sharma",
    status: "Scheduled",
  },
  {
    type: "Task",
    subject: "Send Product Brochure",
    due: "24-Aug-2026",
    owner: "Amit Sharma",
    status: "Open",
  },
];

const ATTACHMENTS = [
  { name: "Requirement_Document.pdf", size: "245 KB", date: "24-Aug-2026" },
  { name: "Company_Profile.pdf", size: "1.2 MB", date: "24-Aug-2026" },
  { name: "Product_Specification.xlsx", size: "350 KB", date: "24-Aug-2026" },
];

const TIMELINE = [
  { time: "23-Aug-2026 09:00 AM", title: "Enquiry Created" },
  { time: "23-Aug-2026 10:00 AM", title: "Qualification Call Completed" },
  { time: "23-Aug-2026 02:30 PM", title: "Requirement Updated" },
  { time: "24-Aug-2026 10:15 AM", title: "Meeting Scheduled" },
];

export default function EnquiryWorkspace() {
  const navigate = useNavigate();
  const { enquiryId } = useParams();
  const [moreOpen, setMoreOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState([
    {
      author: "Amit Sharma",
      time: "24-Aug-2026 03:45 PM",
      text: "Customer is interested in enterprise automation package.",
    },
    {
      author: "Priya Mehta",
      time: "24-Aug-2026 03:50 PM",
      text: "Procurement team details awaited. Will share soon.",
    },
  ]);

  const enquiry = SAMPLE_ENQUIRIES[enquiryId] || {
    number: enquiryId || "Enquiry details",
    date: "19-Oct-2026",
    company: "ABC Manufacturing Ltd.",
    contact: "Rahul Sharma",
    designation: "Purchase Manager",
    mobile: "+91 98765 43210",
    email: "rahul@example.com",
    website: "www.example.com",
    industry: "Manufacturing",
    country: "India",
    state: "Maharashtra",
    city: "Mumbai",
    source: "Website",
    type: "Product Enquiry",
    status: "Qualified",
    priority: "High",
    owner: "Ankit Mehra",
    territory: "Mumbai West",
    productInterest: "Industrial Automation Solution",
    quantity: "15",
    budget: "50 Lakhs",
    expectedTimeline: "3 Months",
    projectValue: "50 Lakhs",
    requirementDescription:
      "Automation solution required for a manufacturing line, interested in complete system integration.",
    campaign: "Automation Campaign",
    score: 82,
    leadScore: 84,
    age: "4 Days",
    activities: 12,
    conversion: 78,
    sla: "On Track",
    lastActivity: "Today 10:15 AM",
    createdBy: "System",
    createdOn: "19-Oct-2026 09:00 AM",
    modifiedBy: "Ankit Mehra",
    modifiedOn: "19-Oct-2026 10:15 AM",
    budgetAvailable: "Yes",
    decisionMaker: "Yes",
    requirementConfirmed: "Yes",
    timelineDefined: "Yes",
    existingVendor: "Unknown",
    competitorIdentified: "Pending",
  };

  const value = (v) => v || "—";

  const showMessage = (action) => {
    window.alert(
      `${action} is a UI placeholder. Backend integration has not been connected yet.`
    );
    setMoreOpen(false);
  };

  const addComment = () => {
    if (!comment.trim()) return;

    setComments((current) => [
      ...current,
      {
        author: "Current User",
        time: new Date().toLocaleString(),
        text: comment.trim(),
      },
    ]);
    setComment("");
  };

  const statusClass = `s-${enquiry.status
    .toLowerCase()
    .replace(/\s+/g, "-")}`;

  return (
    <div className="elosca-enquiry-list elosca-workspace elosca-workspace-reference">
      <div className="elosca-breadcrumb">
        <button onClick={() => navigate("/elosca-crm/enquiry")}>Home</button>
        <span>›</span>
        <span>Sales</span>
        <span>›</span>
        <button onClick={() => navigate("/elosca-crm/enquiry")}>
          Enquiry Management
        </button>
        <span>›</span>
        <strong>{enquiry.number}</strong>
      </div>

      <header className="elosca-record-header">
        <div className="elosca-record-icon" aria-hidden="true">
          <span>▤</span>
        </div>

        <div className="elosca-record-title">
          <div className="elosca-record-number-line">
            <h1>{enquiry.number}</h1>
            <span className={`elosca-status ${statusClass}`}>
              {enquiry.status}
            </span>
          </div>
          <p>{enquiry.productInterest || enquiry.requirementDescription || "Enquiry details"}</p>
        </div>

        <div className="elosca-record-meta">
          <span>Source</span>
          <strong>◉ {enquiry.source}</strong>
        </div>
        <div className="elosca-record-meta">
          <span>Owner</span>
          <strong>♙ {enquiry.owner}</strong>
        </div>
        <div className="elosca-record-meta">
          <span>Territory</span>
          <strong>⌖ {value(enquiry.territory)}</strong>
        </div>
        <div className="elosca-record-meta">
          <span>Created On</span>
          <strong>▦ {enquiry.date}</strong>
        </div>
        <div className="elosca-record-meta">
          <span>Last Activity</span>
          <strong>◷ {enquiry.lastActivity}</strong>
        </div>

        <div className="elosca-record-navigation">
          <button
            className="elosca-btn"
            onClick={() => navigate("/elosca-crm/enquiry")}
          >
            ‹ Back
          </button>
          <button
            className="elosca-btn"
            onClick={() => showMessage("Next enquiry")}
          >
            Next ›
          </button>
          <button
            className="elosca-btn"
            title="Toggle full-screen view"
            onClick={() => document.documentElement.requestFullscreen?.()}
          >
            ⛶
          </button>
        </div>
      </header>

      <section className="elosca-workspace-kpis">
        <Kpi icon="✧" tone="purple" label="AI Score" value={enquiry.score} note="Excellent" />
        <Kpi icon="♙" tone="blue" label="Lead Score" value={enquiry.leadScore} note="High" />
        <Kpi icon="◷" tone="orange" label="Age" value={enquiry.age} note={`Since ${enquiry.date}`} />
        <Kpi icon="☑" tone="green" label="Activities" value={enquiry.activities} note="Open / Completed" />
        <Kpi icon="♢" tone="blue" label="SLA Status" value={enquiry.sla} note="Response within SLA" />
        <Kpi icon="◎" tone="pink" label="Conversion %" value={`${enquiry.conversion}%`} note="High Probability" />
      </section>

      <div className="elosca-workspace-actionbar">
        <ActionButton icon="✎" label="Edit" onClick={() => showMessage("Edit enquiry")} />
        <ActionButton icon="♙" label="Assign" onClick={() => showMessage("Assign enquiry")} />
        <ActionButton icon="♙" label="Qualify" onClick={() => showMessage("Qualify enquiry")} />
        <ActionButton icon="▦" label="Create Activity" onClick={() => showMessage("Create activity")} />
        <ActionButton icon="✉" label="Email" onClick={() => showMessage("Email")} />
        <ActionButton icon="◉" label="WhatsApp" onClick={() => showMessage("WhatsApp")} />
        <button
          className="elosca-reference-action success"
          disabled={enquiry.status !== "Qualified"}
          onClick={() => showMessage("Convert to Lead")}
        >
          ◉ Convert To Lead
        </button>
        <button
          className="elosca-reference-action danger"
          onClick={() => showMessage("Mark Lost")}
        >
          ⊗ Mark Lost
        </button>
        <div className="elosca-more-wrap">
          <button
            className="elosca-reference-action"
            onClick={() => setMoreOpen((open) => !open)}
          >
            More⌄
          </button>
          {moreOpen && (
            <div className="elosca-more-menu">
              {["Close Enquiry", "Cancel Enquiry", "Check Duplicates", "View History"].map(
                (item) => (
                  <button key={item} onClick={() => showMessage(item)}>
                    {item}
                  </button>
                )
              )}
            </div>
          )}
        </div>
      </div>

      <div className="elosca-reference-dashboard">
        <WorkspaceCard title="Enquiry Information" icon="▣">
          <Detail label="Enquiry Number" value={enquiry.number} />
          <Detail label="Enquiry Date" value={enquiry.date} />
          <Detail label="Enquiry Source" value={enquiry.source} />
          <Detail label="Campaign" value={enquiry.campaign} />
          <Detail label="Priority" value={enquiry.priority} badge={enquiry.priority} />
          <Detail label="Territory" value={enquiry.territory} />
          <Detail label="Assigned To" value={enquiry.owner} />
        </WorkspaceCard>

        <WorkspaceCard title="Customer Information" icon="♙">
          <Detail label="Company Name" value={enquiry.company} />
          <Detail label="Contact Person" value={enquiry.contact} />
          <Detail label="Designation" value={enquiry.designation} />
          <Detail label="Mobile" value={enquiry.mobile} />
          <Detail label="Email" value={enquiry.email} />
          <Detail label="Industry" value={enquiry.industry} />
          <Detail
            label="Location"
            value={[enquiry.city, enquiry.state, enquiry.country].filter(Boolean).join(", ")}
          />
        </WorkspaceCard>

        <WorkspaceCard title="Requirement Details" icon="▤">
          <Detail label="Product Interest" value={enquiry.productInterest} />
          <Detail label="Expected Quantity" value={enquiry.quantity} />
          <Detail label="Estimated Budget" value={enquiry.budget} />
          <Detail label="Expected Timeline" value={enquiry.expectedTimeline} />
          <Detail label="Requirement Summary" value={enquiry.requirementDescription} />
        </WorkspaceCard>

        <WorkspaceCard title="Zyra AI Insights" icon="✧" className="elosca-ai-panel">
          <MetricBar label="Qualification Score" value={enquiry.score} suffix="/100" />
          <MetricBar label="Predicted Conversion" value={enquiry.conversion} suffix="%" />
          <Detail label="Buying Intent" value="High" badge="High" />
          <Detail label="Duplicate Risk" value="Low" badge="Low" />
          <Detail label="Lead Quality" value="High" badge="High" />
          <div className="elosca-recommendations">
            <strong>Recommended Actions</strong>
            <ul>
              <li>Schedule Technical Discussion</li>
              <li>Add Procurement Stakeholder</li>
              <li>Send Product Brochure</li>
              <li>Arrange Site Visit</li>
              <li>Convert To Lead Within 48 Hours</li>
            </ul>
          </div>
        </WorkspaceCard>

        <WorkspaceCard title="Qualification Workbench" icon="♧">
          <Detail label="Budget Available" value={enquiry.budgetAvailable} badge={enquiry.budgetAvailable} />
          <Detail label="Decision Maker Identified" value={enquiry.decisionMaker} badge={enquiry.decisionMaker} />
          <Detail label="Requirement Confirmed" value={enquiry.requirementConfirmed} badge={enquiry.requirementConfirmed} />
          <Detail label="Timeline Defined" value={enquiry.timelineDefined} badge={enquiry.timelineDefined} />
          <Detail label="Existing Vendor" value={enquiry.existingVendor} />
          <Detail label="Competitor Identified" value={enquiry.competitorIdentified} />
          <div className="elosca-readiness">
            <strong>Lead Readiness</strong>
            <b>{enquiry.score >= 80 ? "High" : enquiry.score >= 60 ? "Medium" : "Low"}</b>
          </div>
        </WorkspaceCard>

        <WorkspaceCard title="Activities" icon="▣" className="elosca-activities-panel">
          <div className="elosca-reference-table-wrap">
            <table className="elosca-reference-table">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Subject</th>
                  <th>Due Date</th>
                  <th>Owner</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {ACTIVITY_ROWS.map((activity) => (
                  <tr key={activity.subject}>
                    <td>{activity.type}</td>
                    <td>{activity.subject}</td>
                    <td>{activity.due}</td>
                    <td>{activity.owner}</td>
                    <td>
                      <span className={`elosca-activity-status ${activity.status.toLowerCase()}`}>
                        {activity.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </WorkspaceCard>

        <WorkspaceCard title="Timeline" icon="◷">
          <div className="elosca-reference-timeline">
            {TIMELINE.map((item) => (
              <div key={item.title} className="elosca-reference-timeline-item">
                <span />
                <div>
                  <time>{item.time}</time>
                  <p>{item.title}</p>
                </div>
              </div>
            ))}
          </div>
          <button className="elosca-reference-text-button" onClick={() => showMessage("Full timeline")}>
            View Full Timeline
          </button>
        </WorkspaceCard>

        <WorkspaceCard title={`Attachments (${ATTACHMENTS.length})`} icon="▧">
          <div className="elosca-reference-attachments">
            {ATTACHMENTS.map((file) => (
              <div key={file.name}>
                <span className="elosca-file-icon">▤</span>
                <strong>{file.name}</strong>
                <small>{file.size}</small>
                <time>{file.date}</time>
                <button title={`Download ${file.name}`} onClick={() => showMessage("Download attachment")}>
                  ⇩
                </button>
              </div>
            ))}
          </div>
          <button className="elosca-reference-text-button" onClick={() => showMessage("Upload attachment")}>
            Upload More
          </button>
        </WorkspaceCard>

        <WorkspaceCard title="Comments & Collaboration" icon="▣" className="elosca-comments-panel">
          <div className="elosca-comments-list">
            {comments.map((item, index) => (
              <div className="elosca-comment" key={`${item.author}-${index}`}>
                <span className="elosca-comment-avatar">
                  {item.author.split(" ").map((part) => part[0]).join("").slice(0, 2)}
                </span>
                <div>
                  <div className="elosca-comment-heading">
                    <strong>{item.author}</strong>
                    <time>{item.time}</time>
                  </div>
                  <p>{item.text}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="elosca-comment-composer">
            <input
              value={comment}
              onChange={(event) => setComment(event.target.value)}
              placeholder="Write a comment..."
              onKeyDown={(event) => {
                if (event.key === "Enter") addComment();
              }}
            />
            <button onClick={addComment} disabled={!comment.trim()}>
              Post
            </button>
          </div>
        </WorkspaceCard>

        <WorkspaceCard title="Audit Information" icon="♢" className="elosca-audit-panel">
          <div className="elosca-audit-grid">
            <Detail label="Created By" value={enquiry.createdBy} />
            <Detail label="Created On" value={enquiry.createdOn} />
            <Detail label="Modified By" value={enquiry.modifiedBy} />
            <Detail label="Modified On" value={enquiry.modifiedOn} />
          </div>
        </WorkspaceCard>
      </div>
    </div>
  );
}

function Kpi({ icon, tone, label, value, note }) {
  return (
    <article className={`elosca-reference-kpi ${tone}`}>
      <span className="elosca-reference-kpi-icon">{icon}</span>
      <div className="elosca-reference-kpi-body">
        <span>{label}</span>
        <strong>{value}</strong>
        <small>{note}</small>
      </div>
    </article>
  );
}

function ActionButton({ icon, label, onClick }) {
  return (
    <button className="elosca-reference-action" onClick={onClick}>
      <span>{icon}</span>
      {label}
    </button>
  );
}

function WorkspaceCard({ title, icon, className = "", children }) {
  return (
    <article className={`elosca-reference-card ${className}`}>
      <h2>
        <span>{icon}</span>
        {title}
      </h2>
      <div className="elosca-reference-card-body">{children}</div>
    </article>
  );
}

function Detail({ label, value, badge }) {
  const shownValue = value || "—";
  return (
    <div className="elosca-reference-detail">
      <span>{label}</span>
      <b>
        {badge ? (
          <span className={`elosca-reference-badge ${String(badge).toLowerCase().replace(/\s+/g, "-")}`}>
            {shownValue}
          </span>
        ) : (
          shownValue
        )}
      </b>
    </div>
  );
}

function MetricBar({ label, value, suffix }) {
  const percentage = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div className="elosca-reference-metric">
      <div>
        <span>{label}</span>
        <strong>{value}{suffix}</strong>
      </div>
      <div className="elosca-reference-progress">
        <span style={{ width: `${percentage}%` }} />
      </div>
    </div>
  );
}
